import React from 'react';
import './SupplierEcosystem.css';

function SupplierEcosystem() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Supplier Ecosystem</h1>
        <p className="lead">Manage and optimize supplier relationships</p>
      </div>
      
      <div className="content-section">
        <div className="row">
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Supplier Network</h3>
                <p>Build and maintain strong supplier relationships</p>
                <i className="bi bi-diagram-3 feature-icon"></i>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Performance Tracking</h3>
                <p>Monitor and evaluate supplier performance</p>
                <i className="bi bi-graph-up-arrow feature-icon"></i>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Collaboration Tools</h3>
                <p>Enable seamless supplier communication</p>
                <i className="bi bi-people-fill feature-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupplierEcosystem;
